import { render, staticRenderFns } from "./dropoff.vue?vue&type=template&id=b85d7ca0&scoped=true"
import script from "./dropoff.vue?vue&type=script&lang=js"
export * from "./dropoff.vue?vue&type=script&lang=js"
import style0 from "./dropoff.vue?vue&type=style&index=0&id=b85d7ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85d7ca0",
  null
  
)

export default component.exports